module.exports = new __parcel__URL__("10438252.e33ec7d0.png").toString();